import { GfxCompatible, type GfxCompatibleProps } from '@blocksuite/std/gfx';
import {
  BlockModel,
  BlockSchemaExtension,
  defineBlockSchema,
} from '@blocksuite/store';

/** A reference to an App source, action or page, not a copy of its data. */
export type AppResourceBlockProps = GfxCompatibleProps & {
  kind: 'table' | 'action' | 'page';
  sourceId: string;
  title: string;
};
export class AppResourceBlockModel extends GfxCompatible<AppResourceBlockProps>(
  BlockModel
) {}
export const AppResourceBlockSchema = defineBlockSchema({
  flavour: 'affine:app-resource',
  props: (): AppResourceBlockProps => ({
    kind: 'table',
    sourceId: '',
    title: '',
    xywh: '[0,0,280,160]',
    index: 'a0',
    lockedBySelf: true,
  }),
  metadata: {
    role: 'content',
    version: 1,
    parent: ['affine:surface'],
    children: [],
  },
  toModel: () => new AppResourceBlockModel(),
});
export const AppResourceBlockSchemaExtension = BlockSchemaExtension(
  AppResourceBlockSchema
);
